export const getNoticesCategories = state => state.notices.notices;
export const getUserNotices = state => state.notices.userNotices;
export const getIsLoadingNotices = state => state.notices.isLoading;
